// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityQuestion.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  const { isNil, pick, isEqual, find } = require('lodash/fp');

  var m = require('mobx');
  var trackable = require('share/tracking/Izenda.Trackable');

  function SecurityQuestion(data, questions) {
    this.questions = questions;

    var props = {
      // DTO
      securityQuestionId: null,
      answer: null,

      // Computed
      question: function() {
        var matchingQuestion = find(
          function(item) {
            return isEqual(item.securityQuestionId, this.securityQuestionId);
          }.bind(this),
          this.questions
        );

        if (!isNil(matchingQuestion)) {
          return matchingQuestion.question;
        }
      }.bind(this),

      remainingQuestionList: []
    };

    m.extendObservable(trackable(this), props);
    data && this.populate(data);
  }

  SecurityQuestion.prototype.populate = m.action(function(data) {
    this.securityQuestionId = data.securityQuestionId || data.id;
    this.answer = data.answer;
  });

  SecurityQuestion.prototype.buildDataForSaving = function() {
    return pick(['securityQuestionId', 'answer'], this);
  };

  SecurityQuestion.prototype.updateProperty = function(key, value) {
    this[key] = value;
    this.markDirty();
  };

  module.exports = SecurityQuestion;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.SecurityQuestion.js